// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  webSlug:"wickedcom",
  bookingAPI: {
    url: 'https://bookingapi.wickedcampers.com',
    version: 'v1',
    secretKey: '32B31187A982FD6EA25E85FB42BA7',
  },
  autoCampaign:{
    enable:true,
    campaignCode:'Flash'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
